import React, { Component } from 'react'
import { Switch, Route, Link } from "react-router-dom";
import './header.css'

class Header extends Component {
  render() {
    return(
      <div className="header">
        <Link to="/"><h1>Loot Runes</h1></Link>

        <ul>
          <li><Link to="/runes">Runes</Link></li>
          <li><Link to="/bind">Bind</Link></li>
          <li><a href="https://opensea.io/collection/runesmaker" target="_blank" rel="noopener noreferrer">OpenSea</a></li>
          <li><a href="https://twitter.com/LootRunes" target="_blank" rel="noopener noreferrer">Twitter</a></li>
          <li><a href="https://etherscan.io/address/0x6f75edbfb41f94522eed734787fbc78c5688aa1e" target="_blank" rel="noopener noreferrer">Contract</a></li>
        </ul>

        <Switch>
          <Route path="/runes"></Route>
          <Route path="/bind"></Route>
          <Route path="/">
            <p>
              Runes is a collection of 10,101 unique bags randomly generated and carved on chain. Each runes bag contains a set of 1 yin/yang and 7 runes. <br/>
              Compatible with any part of loots. Stats, images, and other functionality are intentionally omitted for others to interpret. <br/>
              Feel free to use RUNES in any way you want!
            </p>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default Header;